import type { To } from 'react-router';
import { Link } from 'react-router';
import { msg } from '@gonfalon/messages/msg';

import { WorkflowKind, WorkflowNotificationKind } from '#utils/pendingChanges/constants';
import { trackPendingChangesEvent } from '#utils/pendingChanges/trackPendingChangesEvent';

export type WorkflowNotificationLinkProps = {
  forceRefresh?: boolean;
  workflowKind: WorkflowKind;
  notificationKind: WorkflowNotificationKind;
  workflowLink?: To;
  pendingChangesLink?: To;
};

export function WorkflowNotificationLink({
  forceRefresh,
  workflowKind,
  notificationKind,
  workflowLink,
  pendingChangesLink,
}: WorkflowNotificationLinkProps) {
  let linkText, linkUrl;

  if (notificationKind === WorkflowNotificationKind.LINK_WORKFLOW) {
    linkText =
      workflowKind === WorkflowKind.APPROVAL_REQUEST
        ? msg('pendingChanges.notificationLink.viewApprovalRequest')
        : msg('pendingChanges.notificationLink.viewScheduledChange');
    linkUrl = workflowLink;
  } else if (notificationKind === WorkflowNotificationKind.LINK_PENDING_CHANGES_DRAWER) {
    linkText = msg('pendingChanges.notificationLink.viewPendingChanges');
    linkUrl = pendingChangesLink;
  }

  const handleClick = () => {
    trackPendingChangesEvent('Pending Changes Toast Notification Link Clicked', {
      workflowKind,
    });
  };

  return linkText && linkUrl ? (
    <Link to={linkUrl} onClick={handleClick} reloadDocument={forceRefresh}>
      {linkText}
    </Link>
  ) : null;
}
